"use client";

import Link from "next/link";
import { useIsMobile } from "@/hooks/use-mobile";
import { FanzzzdIcon } from "@/components/icons";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ModeToggle } from "@/components/mode-toggle";

export function MobileHeader() {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-hairline bg-background/85 px-4 backdrop-blur-md md:hidden">
      <Link href="/" className="flex items-center gap-2 rounded-md">
        <FanzzzdIcon width={20} height={20} />
        <span className="text-sm font-semibold tracking-[-0.01em]">fanzzzd</span>
      </Link>
      <div className="flex items-center gap-1">
        <ModeToggle />
        <SidebarTrigger className="size-8 text-muted-foreground hover:text-foreground" />
      </div>
    </header>
  );
}
